import { CommonModal } from '@components/CommonModal/CommonModal';
import { ArrowLeftIcon } from '@constants/svgs';
import { MODAL_TYPE, ROLE_DATA } from '@utils/constants';
import { Input, Select } from 'antd';
import { TFunction } from 'i18next';
import React, { Dispatch, SetStateAction } from 'react';

const DROP_DOWN_PLACE_HOLDER_KEY = 'COMMON.DROP_DOWN_PLACE_HOLDER';

// Modal types that render at the wider (800px) layout; anything else uses 416px.
const WIDE_MODAL_TYPES: string[] = [
  MODAL_TYPE.DETAIL,
  MODAL_TYPE.UPDATE,
  MODAL_TYPE.REGISTRATION,
  MODAL_TYPE.CONFIRM_UPDATE,
  MODAL_TYPE.CONFIRM_REGISTRATION,
];

const getModalWidth = (modalType: string): number =>
  WIDE_MODAL_TYPES.includes(modalType) ? 800 : 416;

const isIdModalDisabled = (commonUserModal: {
  disableField: boolean;
  modalType: string;
}) =>
  commonUserModal.disableField ||
  commonUserModal.modalType === MODAL_TYPE.UPDATE;

const isFieldDisabledByFlag = (
  commonUserModal: { disableField: boolean },
  isDisabledFlag: boolean
) => commonUserModal.disableField || isDisabledFlag;

const getCompanyModalPlaceholder = (
  isDisableCompanyModal: boolean,
  translate: TFunction<'translation', undefined>
) => (!isDisableCompanyModal ? translate(DROP_DOWN_PLACE_HOLDER_KEY) : '');

const getStoreModalPlaceholder = (
  isDisableStoreModal: boolean,
  modalType: string,
  translate: TFunction<'translation', undefined>
) => {
  const isDetailModal = modalType.includes(MODAL_TYPE.DETAIL);
  return isDisableStoreModal || isDetailModal
    ? ''
    : translate(DROP_DOWN_PLACE_HOLDER_KEY);
};

const getSectorModalPlaceholder = (
  isDisableSectorModal: boolean,
  modalType: string,
  translate: TFunction<'translation', undefined>
) => {
  const isDetailModal = modalType.includes(MODAL_TYPE.DETAIL);
  return isDisableSectorModal || isDetailModal
    ? ''
    : translate(DROP_DOWN_PLACE_HOLDER_KEY);
};

const renderRegistrationBackButton = (
  modalType: string,
  commonUserModal: any,
  setCommonUserModal: any,
  translate: TFunction<'translation', undefined>
) => {
  if (modalType !== MODAL_TYPE.CONFIRM_REGISTRATION) {
    return null;
  }
  return (
    <button
      onClick={() =>
        setCommonUserModal({
          ...commonUserModal,
          disableField: false,
          modalType: MODAL_TYPE.REGISTRATION,
          title: translate('USER_PAGE.REGIS_USER'),
        })
      }
    >
      <ArrowLeftIcon />
    </button>
  );
};

const renderUpdateBackButton = (
  modalType: string,
  commonUserModal: any,
  setCommonUserModal: any,
  translate: TFunction<'translation', undefined>
) => {
  if (modalType !== MODAL_TYPE.CONFIRM_UPDATE) {
    return null;
  }
  return (
    <button
      onClick={() =>
        setCommonUserModal({
          ...commonUserModal,
          disableField: false,
          modalType: MODAL_TYPE.UPDATE,
          title: translate('USER_PAGE.UPDATE_USER'),
        })
      }
    >
      <ArrowLeftIcon />
    </button>
  );
};

interface ICommonUserModalProps {
  FIELDS_CONFIG: any;
  FORM_MODAL: any;
  formModal: any;

  // state
  commonUserModal: {
    visible: boolean;
    modalType: string;
    title: string;
    image?: string;
    message?: string;
    disableField: boolean;
  };
  setCommonUserModal: Dispatch<
    SetStateAction<{
      visible: boolean;
      modalType: string;
      title: string;
      image?: string;
      message?: string;
      disableField: boolean;
    }>
  >;
  setIsDisableProcessCenterModal: any;
  setIsDisableCompanyModal: Dispatch<SetStateAction<boolean>>;
  setIsDisableStoreModal: Dispatch<SetStateAction<boolean>>;
  setIsDisableSectorModal: Dispatch<SetStateAction<boolean>>;
  // processCenterDropdownData: any;
  storeModal: any;
  companyModal: any;
  sectorModal: any;

  // boolean
  isLoadingModal: boolean;
  disableNext: boolean;
  isDisableProcessCenterModal: boolean;
  isDisableStoreModal: boolean;
  isDisableCompanyModal: boolean;
  isDisableSectorModal: boolean;

  //function
  handleValidateForm: () => void;
  handleOpenModalConfirmFinal: () => void;
  handleFinalAction: () => void;
  renderPlaceHolder: () => string;
  handleChangeCompanyModal: (value: string) => void;
  handleChangeRoleModal: (value: string) => void;
  translate: TFunction<'translation', undefined>;
}

const CommonUserModal: React.FC<ICommonUserModalProps> = (props) => {
  const {
    FIELDS_CONFIG,
    FORM_MODAL,
    formModal,

    // state
    commonUserModal,
    setCommonUserModal,
    setIsDisableProcessCenterModal,
    setIsDisableCompanyModal,
    setIsDisableStoreModal,
    setIsDisableSectorModal,
    // processCenterDropdownData,
    storeModal,
    companyModal,
    sectorModal,

    // boolean
    isLoadingModal,
    disableNext,
    // isDisableProcessCenterModal,
    isDisableStoreModal,
    isDisableCompanyModal,
    isDisableSectorModal,

    //function
    handleValidateForm,
    handleOpenModalConfirmFinal,
    handleFinalAction,
    renderPlaceHolder,
    handleChangeCompanyModal,
    handleChangeRoleModal,
    translate,
  } = props;

  return (
    <>
      {commonUserModal.visible && (
        <CommonModal
          isLoading={isLoadingModal}
          width={getModalWidth(commonUserModal.modalType)}
          form={formModal}
          isCloseIcon={false}
          isMaskClosable={false}
          isDisableBtnNext={disableNext}
          title={
            <>
              {renderRegistrationBackButton(
                commonUserModal.modalType,
                commonUserModal,
                setCommonUserModal,
                translate
              )}
              {renderUpdateBackButton(
                commonUserModal.modalType,
                commonUserModal,
                setCommonUserModal,
                translate
              )}
              <span>{commonUserModal.title}</span>
            </>
          }
          visible={commonUserModal.visible}
          modalType={commonUserModal.modalType}
          handleValidateForm={handleValidateForm}
          handleOpenModalConfirmFinal={handleOpenModalConfirmFinal}
          handleFinalAction={handleFinalAction}
          onClose={() => {
            setIsDisableProcessCenterModal(false);
            setIsDisableCompanyModal(false);
            setIsDisableStoreModal(false);
            setIsDisableSectorModal(false);
            setCommonUserModal({
              visible: false,
              modalType: '',
              title: '',
              disableField: false,
            });
          }}
          fieldData={[
            {
              fieldConfig: FIELDS_CONFIG.ID_MODAL,
              element: (
                <Input
                  disabled={isIdModalDisabled(commonUserModal)}
                  size="large"
                  placeholder={translate('COMMON.INPUT_PLACE_HOLDER')}
                  onKeyDown={(event) => {
                    if (event.code === 'Space') {
                      event.preventDefault();
                    }
                  }}
                  maxLength={6}
                  onBlur={(event) => {
                    formModal.setFieldValue(
                      FORM_MODAL.MODAL_USERNAME,
                      event.target.value.trim()
                    );
                  }}
                />
              ),
            },
            {
              fieldConfig: FIELDS_CONFIG.USERNAME_MODAL,
              element: (
                <Input
                  disabled={commonUserModal.disableField}
                  size="large"
                  placeholder={renderPlaceHolder()}
                  maxLength={255}
                  onBlur={(event) => {
                    formModal.setFieldValue(
                      FORM_MODAL.MODAL_NAME,
                      event.target.value.trim()
                    );
                  }}
                />
              ),
            },
            {
              fieldConfig: FIELDS_CONFIG.PASSWORD_MODAL,
              element: (
                <Input.Password
                  onPaste={(e) => e.preventDefault()}
                  style={{ display: 'flex', alignItems: 'center' }}
                  autoComplete="off"
                  disabled={commonUserModal.disableField}
                  maxLength={100}
                  onKeyDown={(event) => {
                    if (event.code === 'Space') {
                      event.preventDefault();
                    }
                  }}
                  size="large"
                  placeholder={renderPlaceHolder()}
                />
              ),
            },
            {
              fieldConfig: FIELDS_CONFIG.COMPANY_MODAL,
              element: (
                <Select
                  disabled={isFieldDisabledByFlag(
                    commonUserModal,
                    isDisableCompanyModal
                  )}
                  size="large"
                  placeholder={getCompanyModalPlaceholder(
                    isDisableCompanyModal,
                    translate
                  )}
                  options={companyModal}
                  onChange={handleChangeCompanyModal}
                />
              ),
            },
            {
              fieldConfig: FIELDS_CONFIG.STORE_MODAL,
              element: (
                <Select
                  disabled={isFieldDisabledByFlag(
                    commonUserModal,
                    isDisableStoreModal
                  )}
                  size="large"
                  placeholder={getStoreModalPlaceholder(
                    isDisableStoreModal,
                    commonUserModal.modalType,
                    translate
                  )}
                  options={storeModal}
                  showSearch
                  optionFilterProp="label"
                />
              ),
            },
            {
              fieldConfig: FIELDS_CONFIG.SECTOR_MODAL,
              element: (
                <Select
                  disabled={isFieldDisabledByFlag(
                    commonUserModal,
                    isDisableSectorModal
                  )}
                  size="large"
                  placeholder={getSectorModalPlaceholder(
                    isDisableSectorModal,
                    commonUserModal.modalType,
                    translate
                  )}
                  options={sectorModal}
                  showSearch
                  optionFilterProp="label"
                />
              ),
            },
            {
              fieldConfig: FIELDS_CONFIG.ROLE_MODAL,
              element: (
                <Select
                  onChange={handleChangeRoleModal}
                  disabled={commonUserModal.disableField}
                  size="large"
                  placeholder={translate(DROP_DOWN_PLACE_HOLDER_KEY)}
                  options={ROLE_DATA}
                />
              ),
            },
          ]}
        />
      )}
    </>
  );
};

export default React.memo(CommonUserModal);
